<template>
  <v-card color="white" flat app class="sticky" elevation="0">
    <v-card color="grey darken-4" tile>
      <v-card-title class="pt-4 pb-8" elevation="0">
        <v-row justify="center">
          <v-tooltip bottom v-for="(item, index) in social_icons" :key="index">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                  icon
                  :href="item.href"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  large
                  class="mx-1"
                >
                  <v-icon :color="hover ? 'teal lighten-1' : 'white'">
                    {{ item.icon }}
                  </v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>{{ item.tooltips }}</span>
          </v-tooltip>
        </v-row>
      </v-card-title>

      <v-card-subtitle>
        <v-row justify="center" class="pt-4 pb-1">
          <div class="white--text title font-weight-light">CHUANLONG ZHOU</div>
        </v-row>
        <v-row justify="center" class="pt-1 pb-4 px-8">
          <p class="white--text subtitle-2 font-weight-light ma-1">
            Ph.D. of Environmental Science, Enthusiast of Data Science
          </p>
        </v-row>
      </v-card-subtitle>
    </v-card>

    <v-row justify="center" class="pa-0 ma-0">
      <v-col lg="12" md="6" sm="5" xm="12" class="pa-0 ma-0" id="outline">
        <v-card elevation="0" tile class="ma-0 pa-0">
            <v-img
              max-height="400px"
              max-width="500px"
              :src="require('@/assets/chuanlong.png')"
            >
            </v-img>
        </v-card>
      </v-col>

      <v-col lg="12" md="6" sm="7" xm="12" class="pa-0 ma-0" id="outline">
        <v-card tile color="white" class="my-4 mx-2 pl-5" elevation="0">
          <v-card-text class="font-weight-light subtitle-1 grey--text pt-0">
            <div>
              <!-- I'm an <b style="color: black">Environmental Scientist</b>, and a
              <b style="color: black">Data Science Enthusiast</b>. -->
              I'm interested in environmental modeling and data analysis
              especially on the topics of
              <u style="color: black"
                >persistent chemicals, air pollutants, health effect, and
                climate change</u
              >. 
              <br/>
              <br/>
              I’m continuously seeking research or teaching opportunities
              that can connect environmental science with state-of-the-art computer science, such as
              <u style="color: black"
                >machine learning, data visualization, and web technology</u
              >.
            </div>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-row justify="center" class="ma-0 pa-0 mt-3 mb-10">
            <v-btn
              color="grey darken-3 white--text"
              height="50"
              class="ma-3 mx-5"
              elevation="5"
              width="250"
              href="\Chuanlong_CV.pdf"
              >Download Full CV
              <v-icon class="ml-5"> mdi-download </v-icon>
            </v-btn>

            <!-- <v-btn
              color="grey darken-3 white--text"
              height="50"
              class="ma-3 mx-3"
              elevation="5"
              width="180"
              href="mailto: zhouchuanlong1988@gmail.com"
              >Contact Me
              <v-icon class="ml-5"> mdi-email </v-icon>
            </v-btn> -->
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "leftbar",
  data: () => ({
    social_icons: [
      {
        tooltips: "Email",
        icon: "mdi-email",
        href: "mailto: zhouchuanlong1988@gmail.com",
      },
      {
        tooltips: "Google Scholar",
        icon: "$google_scholar_icon",
        href: "https://scholar.google.com/citations?user=I1xZXuEAAAAJ&hl=da",
      },
      {
        tooltips: "ResearchGate",
        icon: "$research_gate_icon",
        href: "https://www.researchgate.net/profile/Chuanlong_Zhou",
      },

      {
        tooltips: "GitHub (work)",
        icon: "mdi-github",
        href: "https://github.com/chuanlongZhou",
      },
      {
        tooltips: "GitHub (personal)",
        icon: "mdi-github",
        href: "https://github.com/defve1988",
      },
      {
        tooltips: "LinkedIn",
        icon: "mdi-linkedin",
        href: "https://www.linkedin.com/in/chuanlong-zhou-764a12115",
      },
      // {
      //   tooltips: "Twitter",
      //   icon: "mdi-twitter",
      //   href: "https://twitter.com/defve5",
      // },
    ],
  }),
};
</script>

<style scoped>
span {
  display: inline-block;
  vertical-align: middle;
}
</style>

<style scoped>
/* NOTE: span does not support margin or padding top, only vertical-align can be used*/
div #outline {
  /* outline: 0.5px solid grey; */
  border-left: 0.25px solid rgb(216, 216, 216);
  border-right: 0.25px solid rgb(216, 216, 216);
}
div .sticky {
  position: sticky;
  top: 0;
}
</style>